import React from 'react';
import { Box, Radio, FormControlLabel, RadioGroup, Chip } from '@mui/material';
import { MERGE_PRODUCT_DURATION } from '@src/constants/package';
import { useTranslation } from 'react-i18next';
import { YearlyContainer } from './index.style';

const ChangeDuration = ({
  saveUpToPercent,
  onChangeTab,
  activeGranularity,
  disabled = false,
}) => {
  const { t } = useTranslation();

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1, p: '20px' }}>
      <RadioGroup
        defaultValue={activeGranularity}
        onChange={(e) => onChangeTab(e.target.value)}
      >
        <FormControlLabel
          style={{
            cursor:
              disabled && activeGranularity !== MERGE_PRODUCT_DURATION.MONTHLY
                ? 'not-allowed'
                : 'default',
          }}
          value={MERGE_PRODUCT_DURATION.MONTHLY}
          checked={activeGranularity === MERGE_PRODUCT_DURATION.MONTHLY}
          disabled={disabled}
          control={
            <Radio
              sx={{
                color: '#1E164EA3',
                '&.Mui-checked': {
                  color: '#1E164E',
                },
              }}
            />
          }
          label={t('monthly')}
          sx={{
            '& .MuiFormControlLabel-label': {
              color: '#1E164EA3',
              fontSize: '14px',
            },
          }}
          componentsProps={{
            typography: {
              sx: {
                color: '#1E164EA3',
                fontSize: '14px',
                '.Mui-checked ~ &': {
                  color: '#1C1C1E !important',
                },
              },
            },
          }}
        />
        <YearlyContainer>
          <FormControlLabel
            style={{
              cursor:
                disabled && activeGranularity !== MERGE_PRODUCT_DURATION.YEARLY
                  ? 'not-allowed'
                  : 'default',
            }}
            value={MERGE_PRODUCT_DURATION.YEARLY}
            checked={activeGranularity === MERGE_PRODUCT_DURATION.YEARLY}
            disabled={disabled}
            control={
              <Radio
                sx={{
                  color: '#1E164EA3',
                  '&.Mui-checked': {
                    color: '#1E164E',
                  },
                }}
              />
            }
            label={t('yearly')}
            sx={{
              '& .MuiFormControlLabel-label': {
                color: '#1E164EA3',
                fontSize: '14px',
              },
            }}
            componentsProps={{
              typography: {
                sx: {
                  color: '#1E164EA3',
                  fontSize: '14px',
                  '.Mui-checked ~ &': {
                    color: '#1C1C1E !important',
                  },
                },
              },
            }}
          />
          <Chip
            label={t('discountPercent', { percent: saveUpToPercent })}
            size="small"
            sx={{
              backgroundColor: '#FFD60A',
              padding: '4px 8px',
              boxSizing: 'border-box',
              borderRadius: '4px',
              color: '#1C1C1E',
              fontWeight: 500,
              fontSize: '12px',
              height: '24px',
            }}
          />
        </YearlyContainer>
      </RadioGroup>
    </Box>
  );
};
export default ChangeDuration;
